import { Pipe, PipeTransform } from '@angular/core';
import { SalesByMenuCategoryResponse, MenuCategoryItem } from '../../models';

/**
 * Pipe to calculate total quantity for a specific category
 */
@Pipe({
  name: 'categoryTotalQuantity'
})
export class CategoryTotalQuantityPipe implements PipeTransform {
  transform(
    categoryName: string,
    salesData: SalesByMenuCategoryResponse
  ): number {
    if (!salesData || !categoryName || !salesData[categoryName]) {
      return 0;
    }

    const categoryItems = salesData[categoryName];
    if (!Array.isArray(categoryItems)) {
      return 0;
    }

    return categoryItems.reduce(
      (total, item: MenuCategoryItem) =>
        total + (parseInt(item.total_quantity as any, 10) || 0),
      0
    );
  }
}

/**
 * Pipe to calculate total sales amount for a specific category
 */
@Pipe({
  name: 'categoryTotalSales'
})
export class CategoryTotalSalesPipe implements PipeTransform {
  transform(
    categoryName: string,
    salesData: SalesByMenuCategoryResponse
  ): number {
    if (!salesData || !categoryName || !salesData[categoryName]) {
      return 0;
    }

    const categoryItems = salesData[categoryName];
    if (!Array.isArray(categoryItems)) {
      return 0;
    }

    return categoryItems.reduce(
      (total, item: MenuCategoryItem) =>
        total + (parseFloat(item.total_sales as any) || 0),
      0
    );
  }
}
